import {AddressStatusCodec, UserStatusCodec} from '../codecs';
import {buildManagedStorage, createSessionStorageInMemoryDuplicationDriver} from '../ManagedStorage';

// this is the only place using sessionStorage is allowed
// eslint-disable-next-line no-restricted-globals
const driver = createSessionStorageInMemoryDuplicationDriver({sessionStorage});

const v = 'v21.30.0';
const ss = buildManagedStorage(v, driver, ({entry, codecs}) => ({
    addressStatus: entry('addressStatus', AddressStatusCodec),
    authRoles: entry('authRoles', {
        decode: (string): readonly string[] => string.split(','),
        encode: value => value.join(','),
    }),

    authToken: entry('authToken'),
    authStatus: entry('auth_status', UserStatusCodec),

    applyForKyc: entry('ApplyForKyc', codecs.boolean),
    uuid: entry('uuid'),

    hPass: entry('hPass'),
    inviteCodeSession: entry('invite_code_session'),
    refreshToken: entry('refreshToken'),
    stripeSecret: entry('stripeSecret'),
    userId: entry('userId'),
    username: entry('username'),
}));

export default {[v]: ss};
